import Phaser from 'phaser';
import { SCENE_KEYS, type SceneKey } from './scenes';

function getUrlParams() {
  if (typeof window === 'undefined') {
    return null;
  }
  return new URL(window.location.href).searchParams;
}

export function getInitialSceneKey(): SceneKey {
  const params = getUrlParams();
  const requested = params?.get('scene');
  if (requested && SCENE_KEYS.includes(requested as SceneKey)) {
    return requested as SceneKey;
  }
  return SCENE_KEYS[0];
}

export function hasUrlFlag(flag: string) {
  const params = getUrlParams();
  if (!params) {
    return false;
  }
  const value = params.get(flag);
  return value === '1' || value === 'true';
}

export function createGameConfig(
  scenes: Array<new (...args: unknown[]) => Phaser.Scene>,
): Phaser.Types.Core.GameConfig {
  const width = Math.min(960, typeof window !== 'undefined' ? window.innerWidth : 960);
  const height = Math.min(540, typeof window !== 'undefined' ? window.innerHeight : 540);

  return {
    type: Phaser.AUTO,
    parent: 'game',
    width,
    height,
    backgroundColor: '#050510',
    pixelArt: true,
    roundPixels: true,
    physics: {
      default: 'arcade',
      arcade: { gravity: { x: 0, y: 900 }, debug: false },
    },
    scale: {
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    scene: scenes,
    banner: false,
  };
}
